import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Country, CountriesResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class CountriesDataService {

  private uri: string = `${environment.apiUrl}countries`;
  private cacheKey: string = 'countries.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getCountry(id: number): Observable<Country|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getCountries(parameters: {[param: string]: string | string[]}): Observable<CountriesResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addCountry(data: Country): Observable<Country|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addCountries(data: Country[]): Observable<Country[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateCountry(data: Country): Observable<Country|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateCountries(data: Country[]): Observable<Country[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchCountry(data: Country): Observable<Country|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchCountries(data: Country[]): Observable<Country[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteCountry(data: Country): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteCountries(data: Country[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((country) => {
      ids.push(country.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
